import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f70ef6f6558f0014f21b0e_1787933025123_dc3faacd/handlenders/src/app/directory/page.tsx");
